export default __webpack_public_path__ + "static/media/yellow.ead0b5a8.png";